export default {
    getFriends(state){
        return state.friends;
    },
    getRecommender(state){
        return state.recommenders;
    },
    getItemsValidity(state){
        return state.itemValidity;
    },
    getItemUse(state){
        return state.itemUse;
    },
}
